import { useState } from "react";
import { Link } from "react-router-dom";
import { m as motion } from "framer-motion";
import { EXTERNAL_LINKS } from "../lib/constants";
import { MEMBER_SHOWCASE_PATH } from "@/lib/routes";
import { defaultViewport } from "@/lib/motion";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Redirect to newsletter signup with email
    window.open(`https://newsletter.workplacelabs.io`, "_blank");
    setEmail("");
  };

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={defaultViewport}
      transition={{ duration: 0.5 }}
      className="relative border-t border-border/50 glass-strong"
    >
      <div className="section-inner">
        <div className="grid md:grid-cols-3 gap-8 py-12">
          {/* Logo and Branding */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <Link to="/" className="flex items-center group">
              <motion.img
                whileHover={{ scale: 1.02 }}
                transition={{ type: "spring", stiffness: 400 }}
                src="/images/ai-for-hr-mastermind-logo.png"
                alt="AI for HR Mastermind"
                className="h-12 sm:h-14 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground text-center md:text-left">
              A{" "}
              <a
                href="https://www.workplacelabs.io"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-foreground hover:text-primary transition-colors duration-300 underline underline-offset-4"
              >
                Workplace Labs
              </a>{" "}
              program.
            </p>
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} All rights reserved.
            </p>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-col items-center md:items-start gap-3 text-sm">
            <p className="font-semibold text-foreground mb-1">Quick Links</p>
            <Link
              to="/faq"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              FAQ
            </Link>
            <Link
              to="/about-us"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              About Us
            </Link>
            <Link
              to="/team-training"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Team Training
            </Link>
            <Link
              to="/contact"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Contact Us
            </Link>
            <Link
              to="/workshops"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Workshops
            </Link>
            <Link
              to={MEMBER_SHOWCASE_PATH}
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Member Showcase
            </Link>
            <a
              href={EXTERNAL_LINKS.PREMIUM_MASTERMIND_APPLICATION}
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Apply Now
            </a>
          </nav>

          {/* Ecosystem Links */}
          <div className="flex flex-col items-center md:items-start gap-3 text-sm">
            <p className="font-semibold text-foreground mb-1">Workplace Labs</p>
            <a
              href="https://www.workplacelabs.io"
              target="_blank"
              rel="noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Workplace Labs →
            </a>
            <a
              href="https://newsletter.workplacelabs.io"
              target="_blank"
              rel="noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Newsletter →
            </a>
            <a
              href="https://www.workplacelabs.io/products"
              target="_blank"
              rel="noreferrer"
              className="text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              Products →
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-hero opacity-50" />
    </motion.footer>
  );
};
